import React from 'react';
import { OrganicEventSearchFiltersApiPayload } from '../hooks/types';

interface SearchProviderShape {
    query: OrganicEventSearchFiltersApiPayload;
    setQuery?: (newQuery: OrganicEventSearchFiltersApiPayload) => void;
}

export const INITIAL_QUERY: OrganicEventSearchFiltersApiPayload = {
    page_size: 8,
    exclude: { ids: [] },
    aggs: {
        tags: { size: 50 },
        organizertagsautocomplete_agg: { size: 50 },
        dates: {},
    },
    page_type: '',
    dates: ['current_future'],
    tags: [],
};

export const useSearchContext = () => {
    const value = React.useContext(SearchContext);

    if (value === undefined) {
        throw new Error('useSearchContext must be used within SearchProvider');
    }

    return value;
};

const SearchContext = React.createContext<SearchProviderShape>({
    query: INITIAL_QUERY,
});
